



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Sketch } from 'vue-color';

@Component({
  components: {
    Sketch,
  },
})
export default class ColorPicker extends Vue {
  // Prop to accept the previous color
  @Prop({ default: '#FFFFFF' }) previousColor!: string;

  color = this.previousColor;
  pickerColor: { hex: string } = { hex: this.previousColor };
  showPicker = false;

  // Toggle the color picker visibility
  togglePicker() {
    this.showPicker = !this.showPicker;
  }

  // Update the picker color when user selects in the Sketch picker
  updateColor(newColor: { hex: string }) {
    this.pickerColor = newColor;
  }

  // Confirm the color selection
  confirmColor() {
    this.color = this.pickerColor.hex;
    this.$emit('color_selected', this.color);
    this.showPicker = false;
  }

  // Emit color when user types manually in the input box
  updateColorInput() {
    this.$emit('color_selected', this.color);
  }
}
